"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.statusTransitionForAccountingDocument = exports.StatusTransitionsForAccountingDocument = void 0;
const base_1 = require("./base");
const entities_1 = require("../entities");
const contact_profile_enum_1 = require("../entities/contact-profile-enum");
class StatusTransitionsForAccountingDocument extends base_1.StatusTransition {
    constructor() {
        super(...arguments);
        this.allowedTransitions = [
            {
                from: [entities_1.AccountingDocumentStatusEnum.DRAFT],
                to: [entities_1.AccountingDocumentStatusEnum.PENDING],
            },
            {
                from: [entities_1.AccountingDocumentStatusEnum.PENDING],
                to: [entities_1.AccountingDocumentStatusEnum.CREATED],
            },
            {
                from: [entities_1.AccountingDocumentStatusEnum.CREATED],
                to: [entities_1.AccountingDocumentStatusEnum.SEND_PENDING],
            },
            {
                from: [entities_1.AccountingDocumentStatusEnum.SEND_PENDING],
                to: [
                    entities_1.AccountingDocumentStatusEnum.SEND_PENDING,
                    entities_1.AccountingDocumentStatusEnum.SENT,
                ],
            },
            {
                from: [entities_1.AccountingDocumentStatusEnum.SENT],
                to: [entities_1.AccountingDocumentStatusEnum.SENT],
            },
            {
                from: [entities_1.AccountingDocumentStatusEnum.CREATED],
                to: [entities_1.AccountingDocumentStatusEnum.CANCELLATION_PENDING],
            },
            {
                from: [
                    entities_1.AccountingDocumentStatusEnum.PAID,
                    entities_1.AccountingDocumentStatusEnum.RECEIVED,
                    entities_1.AccountingDocumentStatusEnum.SEND_PENDING,
                    entities_1.AccountingDocumentStatusEnum.SENT,
                ],
                to: [entities_1.AccountingDocumentStatusEnum.CANCELLATION_PENDING],
                permissions: new Set([contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER]),
            },
            {
                from: [entities_1.AccountingDocumentStatusEnum.CANCELLATION_PENDING],
                to: [entities_1.AccountingDocumentStatusEnum.CANCELLED],
            },
            {
                from: [entities_1.AccountingDocumentStatusEnum.CANCELLED],
                to: [entities_1.AccountingDocumentStatusEnum.CANCELLATION_SEND_PENDING],
            },
            {
                from: [entities_1.AccountingDocumentStatusEnum.CANCELLATION_SEND_PENDING],
                to: [entities_1.AccountingDocumentStatusEnum.CANCELLATION_SENT],
            },
            {
                from: [
                    entities_1.AccountingDocumentStatusEnum.RECEIVED,
                    entities_1.AccountingDocumentStatusEnum.SENT,
                ],
                to: [entities_1.AccountingDocumentStatusEnum.PAID],
            },
        ];
    }
}
exports.StatusTransitionsForAccountingDocument = StatusTransitionsForAccountingDocument;
exports.statusTransitionForAccountingDocument = new StatusTransitionsForAccountingDocument();
//# sourceMappingURL=accounting-document.js.map